// Calendar days as YYYY-MM-DD strings, the form the services use. All the
// arithmetic happens at UTC midnight, so adding a day never lands on the wrong
// date across a daylight-saving change; only today is read from the device,
// because the person's day is the one their own clock shows.

function at(day) {
  return new Date(`${ day }T00:00:00Z`);
}

function format(date) {
  return date.toISOString().slice(0, 10);
}

export function today() {
  return dayOf(new Date());
}

export function addDays({ day, days }) {
  const date = at(day);

  date.setUTCDate(date.getUTCDate() + days);

  return format(date);
}

// The Monday of the week a day is in: weeks start on Monday, as in Italy.
export function weekStart(day) {
  const date = at(day);
  const offset = (date.getUTCDay() + 6) % 7;

  return addDays({ day, days: -offset });
}

export function monthStart(day) {
  return `${ day.slice(0, 7) }-01`;
}

export function monthEnd(day) {
  const date = at(monthStart(day));

  date.setUTCMonth(date.getUTCMonth() + 1);
  date.setUTCDate(0);

  return format(date);
}

// The same day of the month `months` away, moved back to the month's last day
// when it has fewer days (31 March minus one month is 28 or 29 February).
export function addMonths({ day, months }) {
  const first = at(monthStart(day));

  first.setUTCMonth(first.getUTCMonth() + months);

  const last = monthEnd(format(first));
  const wanted = `${ format(first).slice(0, 8) }${ day.slice(8) }`;

  if (wanted > last) {
    return last;
  }

  return wanted;
}

export function isDay(value) {
  if (typeof value !== 'string' || /^\d{4}-\d{2}-\d{2}$/.test(value) === false) {
    return false;
  }

  return Number.isNaN(at(value).getTime()) === false && format(at(value)) === value;
}

// The calendar day an instant falls on by the device's clock, such as the
// day a questionnaire was submitted.
export function dayOf(instant) {
  const date = new Date(instant);

  return `${ date.getFullYear() }-${ String(date.getMonth() + 1).padStart(2, '0') }-${ String(date.getDate()).padStart(2, '0') }`;
}

// A day written for people, in the device language: "Wed 7 October" on a
// phone line, the month alone for the chart, "14 Oct" in a short line, or
// "Monday 14 September 2026" in full, as a chart day is named for assistive
// technology.
export function describe({ day, language, month, short, full }) {
  let options = { weekday: 'short', day: 'numeric', month: 'long', timeZone: 'UTC' };

  if (month === true) {
    options = { month: 'long', year: 'numeric', timeZone: 'UTC' };
  }

  if (short === true) {
    options = { day: 'numeric', month: 'short', timeZone: 'UTC' };
  }

  if (full === true) {
    options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' };
  }

  return new Intl.DateTimeFormat(language, options).format(at(day));
}
